import React from "react";

// This was originally an <embed> but <iframe> seemed more appropriate.
// Scrolling could be removed with the deprecated scrolling="no" attribute
// but it is needed on smaller screens.
export default function EmbedViewer(props) {
  return (
    <iframe
      src="https://curblr.turnstone.dev/"
      style={{ border: 0, flexGrow: 1 }}
      title="CurbLR Regulation Map for Bellevue, WA"
    />
  );
}
